<template>
  <div id="app">

    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <Map/> -->
    <!-- <MapBays/> -->
    <MapFiveDocks/>
  </div>
</template>

<script>
import Map from './components/Map.vue'
import MapBays from './components/MapBays.vue'
import MapFiveDocks from './components/MapFiveDocks.vue'

export default {
  name: 'app',
  components: {
    Map,
    MapBays,
    MapFiveDocks
  }
}
</script>

<style>
html,body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
#app {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>
